
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'ArrowSVG',
})
export default class ArrowSVG extends Vue {}
